export default __webpack_public_path__ + "static/SylvanLearning-79c17c9e38b3862ca40041b554cf04b4.png";